'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Layout from 'Layouts/Auth';
import Button from '@material-ui/core/Button';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import Logo from 'Pure/Logo';
import Link from 'Pure/Link';
import { front_urls, URL } from 'Shared/Routes';
let app = typeof window !== 'undefined' ? window.app : undefined;
export default class NotAllowedPage extends Component {
  state = {
    roles: []
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
    if (app.state.session.fetched) {
      component.handleSessionChange({
        source: 'DidMount'
      });
    }
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
  }
  handleSessionChange = ({
    source,
    data
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      roles: app.state.session.user?.roles || []
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus({
      error: app.state.form_error
    });
    const default_error = state.roles.length === 0 ? 'Connectez-vous pour accéder à cette page' : 'Vous n\'avez pas la permission d\'accéder à cette page.';
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Acc\xE8s refus\xE9"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "login-page__left"
    }, /*#__PURE__*/React.createElement("div", {
      className: "u-full-width"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "auth-logo-link",
      href: URL('Login', front_urls)
    }, /*#__PURE__*/React.createElement(Logo, {
      style: {
        width: '240px',
        maxWidth: '100%',
        margin: 'auto'
      }
    })), status.length === 0 ? getFormStatus({
      error: default_error
    }) : status, /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-margin-top-25\r u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "secondary",
      size: "small",
      href: URL('HomePage'),
      component: Link
    }, "Retour a l'accueil")))), /*#__PURE__*/React.createElement("div", {
      className: "login-page__right"
    }, /*#__PURE__*/React.createElement("div", {
      className: "u-full-width"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "login-page__title"
    }, "Acc\xE8s refus\xE9"))));
    return output;
  }
}
